import { render } from "./AboutElectrologist.vue?vue&type=template&id=6c0aa46e"
import script from "./AboutElectrologist.vue?vue&type=script&lang=js"
export * from "./AboutElectrologist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__